import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Polygon } from '@react-google-maps/api';
import { getZoneOptions } from 'helpers/utils';

const ViewNearbyZonesPolygon = () => {
  const [nearbyZonesPolygon, setNearbyZonesPolygon] = useState([]);
  const zoneState = useSelector((state) => state.zone.geoRadarZone) ?? null;

  useEffect(() => {
    if (zoneState.nearbyZones?.length > 0) {
      const nearbyZones = zoneState.nearbyZones.map((zone, index) => {
        const convertCoordinates = (coordinates) => {
          return coordinates?.map((coord) => {
            return { lat: coord.latitude, lng: coord.longitude };
          });
        };

        const paths = convertCoordinates(zone.zonePolygon);

        return (
          <Polygon
            key={index}
            paths={paths}
            options={getZoneOptions({
              strokeOpacity: 0.8,
              fillColor: zone.color,
              editable: false,
              fillOpacity: zone.transparency ?? 0.2,
            })}
          />
        );
      });

      setNearbyZonesPolygon(nearbyZones);
    } else {
      setNearbyZonesPolygon([]);
    }
  }, [zoneState.nearbyZones]);

  return <>{nearbyZonesPolygon.length > 0 && nearbyZonesPolygon}</>;
};

export default ViewNearbyZonesPolygon;
